export default __webpack_public_path__ + "static/media/jacuzzi-view-2.4959451b.jpg";